import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Grid, Button } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ErrorAlert from 'components/ErrorAlert';
import SubmittingButton from 'components/SubmittingButton';
import { updateQueryString } from 'services/router/actions';
import { requestCompleteFertilizerEvents } from 'services/fertilizerEvents/actions';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

import pluralize from 'utils/pluralize';
import { FERTILIZER_EVENTS_COMPLETE_NAMESPACE } from 'services/fertilizerEvents/constants';
import { FERTILIZER_EVENTS_COMPLETE_MODAL } from 'scenes/Fertilizer/constants';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';
import { selectSelectedIncompleteFertilizerEventsUuids } from '../FertilizerEventsVirtualizedTable/selectors';

interface ConnectedProps {
    completeFertilizerEventModal: boolean;
    uuids: FertilizerEventUuid[];
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestCompleteFertilizerEvents: typeof requestCompleteFertilizerEvents;
}

type Props = ConnectedProps & DispatchProps;

export class FertilizerEventCompleteModalComponent extends React.PureComponent<Props> {
    get open(): boolean {
        const { completeFertilizerEventModal, uuids } = this.props;

        return !!completeFertilizerEventModal && !!uuids && !!uuids.length;
    }

    handleClose = (): void => {
        const { props } = this;

        props.updateQueryString({
            [FERTILIZER_EVENTS_COMPLETE_MODAL]: undefined
        });
    };

    handleCompleteFertilizerEvent = (): void => {
        const { uuids, ...props } = this.props;

        props.requestCompleteFertilizerEvents(uuids);
    };

    render(): React.ReactElement {
        const { uuids } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace={FERTILIZER_EVENTS_COMPLETE_NAMESPACE}
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            Complete Fertilizer{' '}
                            {pluralize(uuids.length, 'Event', 'Events')}
                        </Modal.Header>
                        <Modal.Content>
                            <p>
                                Are you sure you want to complete {uuids.length}{' '}
                                fertilizer{' '}
                                {pluralize(uuids.length, 'event', 'events')}?
                            </p>
                            <ErrorAlert
                                namespace={FERTILIZER_EVENTS_COMPLETE_NAMESPACE}
                            />
                            <Grid>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Button
                                        type="button"
                                        onClick={this.handleClose}
                                        fluid
                                        basic
                                        primary
                                    >
                                        Cancel
                                    </Button>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmittingButton
                                        type="button"
                                        namespace={
                                            FERTILIZER_EVENTS_COMPLETE_NAMESPACE
                                        }
                                        primary
                                        fluid
                                        onClick={
                                            this.handleCompleteFertilizerEvent
                                        }
                                    >
                                        Complete
                                    </SubmittingButton>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    completeFertilizerEventModal: makeSelectQueryStringValue(
        FERTILIZER_EVENTS_COMPLETE_MODAL
    ),
    uuids: selectSelectedIncompleteFertilizerEventsUuids
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestCompleteFertilizerEvents
})(FertilizerEventCompleteModalComponent);
